const usersEn = {
    profile: require('lang/en/users/Profile').default,
    user: require('lang/en/users/User').default,
};

export default usersEn;